// 列表和表单里的日期显示：逾期天数、今天/明天、10/24 周六 14:00
const weekNames = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
const pad = n => String(n).padStart(2, '0')

export function dayString(date) {
  return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate())
}
export function today() {
  return dayString(new Date())
}
export function parseDay(text) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(text || ''))
  return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : null
}
export function addDays(text, days) {
  const date = parseDay(text) || new Date()
  date.setDate(date.getDate() + days)
  return dayString(date)
}
export function daysFromToday(text) {
  const date = parseDay(text)
  if (!date) return null
  return Math.round((date - parseDay(today())) / 86400000)
}
export function weekday(text) {
  const date = parseDay(text)
  return date ? weekNames[date.getDay()] : ''
}
export function clock(text) {
  const m = /[ T](\d{2}):(\d{2})/.exec(String(text || ''))
  return m && !(m[1] === '00' && m[2] === '00') ? m[1] + ':' + m[2] : ''
}
// 10/24 周六 14:00；同一年不写年份
export function dateTimeText(text, withWeek = true) {
  const date = parseDay(text)
  if (!date) return ''
  const sameYear = date.getFullYear() === new Date().getFullYear()
  const head = (sameYear ? '' : date.getFullYear() + '/') + (date.getMonth() + 1) + '/' + date.getDate()
  const time = clock(text)
  return [head, withWeek ? weekNames[date.getDay()] : '', time].filter(Boolean).join(' ')
}
// 下次跟进时间在列表里的写法
export function dueInfo(text) {
  const days = daysFromToday(text)
  if (days === null) return { late: false, main: '—', sub: '未安排' }
  if (days < 0) return { late: true, main: -days + ' 天', sub: '逾期' }
  if (days === 0) return { late: false, main: clock(text) || '今天', sub: clock(text) ? '今天' : '到期' }
  if (days === 1) return { late: false, main: '明天', sub: clock(text) || '跟进' }
  const date = parseDay(text)
  const sub = date.getFullYear() === new Date().getFullYear() ? weekNames[date.getDay()] : date.getFullYear() + '年'
  return { late: false, main: date.getMonth() + 1 + '/' + date.getDate(), sub }
}
export function tail(mobile) {
  const text = String(mobile || '')
  return /^\d{11}$/.test(text) ? '尾号 ' + text.slice(-4) : ''
}
// 关键词是客户最能被认出的信息，没有时退回项目名
export function needText(customer) {
  const keyword = String((customer && customer.keyword) || '')
    .replace(/\s+/g, ' ')
    .trim()
  if (keyword) return keyword
  const subject = String((customer && customer.subject_text) || '').replace(/-+$/, '')
  return subject || '还没有填写需求'
}
export function projectText(text) {
  const parts = String(text || '')
    .split('-')
    .filter(Boolean)
  return parts.length ? parts[0] : ''
}
export function projectType(text) {
  const parts = String(text || '')
    .split('-')
    .filter(Boolean)
  return parts.length > 1 ? parts[parts.length - 1] : ''
}



// WEBPACK FOOTER //
// ./src/common/when.js